<template>
  <v-row align="center" justify="center" v-if="!$store.getters.logged">
    <v-col cols="12" sm="8" md="4">
      <v-card class="elevation-4">
        <CsrfToken @loaded="csrf_token" />
        <v-card-text>
          Buscando os dados de usuário e token de acesso...
        </v-card-text>
      </v-card>
      <v-overlay :value="loading">
        <PProgressCircular indeterminate size="64" />
      </v-overlay>
    </v-col>
  </v-row>
</template>
<script>
import PProgressCircular from "../PProgressCircular/PProgressCircular";
import CsrfToken from "../CSRFToken/CSRFToken.vue";

import loginCas from "../../api/loginCas";
import { store } from "../../api/store";
import CSRF from "../../api/csrfMixin";

export default {
  mixins: [CSRF()],

  components: {
    CsrfToken,
    PProgressCircular,
  },

  props: ["loginRedirect", "loginCallback"],

  data: () => ({
    loading: false,
  }),

  mounted() {
    setTimeout(() => {
      this.get_token();
    }, 1000);
  },

  methods: {
    get_token: function () {
      this.loading = true;
      let username = this.$route.query.name;
      let auth_code = this.$route.query.auth_code;
      let code_verifier = localStorage.getItem("code_verifier");

      loginCas.API.Actions.login_cas(
        username,
        code_verifier,
        auth_code,
        this._token
      )
        .then((resp) => {
          if (resp.status == 200) {
            store.dispatch("login", resp.data).then(() => {
             if (this.loginCallback) this.loginCallback(resp.data);

              this.$router.push({ name: this.loginRedirect });
              this.loading = false;
            });
          } else {
            this.$router.push({ name: "login" });
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
          alert("Não foi possivel fazer login!");
        });
    },
  },
};
</script>